import { createFeatureSelector, createSelector } from '@ngrx/store'
import { UserDetailState, UserState } from './user.state'
import { AuthState } from '../auth/auth.state'

export const selectUserState = createFeatureSelector<UserState>('user')

export const selectAllUsers = createSelector(selectUserState, (state: UserState) => state.users)

export const selectSelectedUser = createSelector(selectUserState, state => state)

// Selector to get the total count of users/employees
export const selectTotalCount = createSelector(
  selectUserState,
  (state: UserState) => state.totalCount
)

// Selector to get the total count of businesses
export const selectActiveCount = createSelector(
  selectUserState,
  (state: UserState) => state.activeCount
)

// Selector to get the total count of businesses
export const selectInactiveCount = createSelector(
  selectUserState,
  (state: UserState) => state.inactiveCount
)

export const selectNewJoineeCount = createSelector(
  selectUserState,
  (state: UserState) => state.newJoineeCount
)

export const selectEmployeeById = (userId: string) =>
  createSelector(selectAllUsers, users => users.find(user => user.id === userId))

// Select the feature state
export const selectEmployeeDetailState = createFeatureSelector<UserDetailState>('user')
export const selectEmployeeDetail = createSelector(
  selectEmployeeDetailState,
  (state: UserDetailState) => state.user
)

export const selectEmployeeDetailError = createSelector(
  selectEmployeeDetailState,
  (state: UserDetailState) => state.error
)

export const selectUserFeature = createFeatureSelector<AuthState>('user')
export const selectUserRoles = createSelector(
  selectUserFeature,
  (state: AuthState) => state.user?.userRoles
)
